import { on } from '@ngrx/store';
import { signedInUserActions } from './signed-in-user.actions';
import { createSessionRehydrateReducer } from './createSessionRehydrateReducer';

export interface SignedInUserState {
  user: any;
}

export const initialSignedInUserState: SignedInUserState = {
  user: null,
};

export const signedInUserReducer = createSessionRehydrateReducer(
  'signed-in-user',
  initialSignedInUserState,
  on(signedInUserActions.login, (state, { user }): SignedInUserState => ({ ...state, user })),
  on(signedInUserActions.logout, (state): SignedInUserState => ({ ...state, user: null }))
);